import * as tslib_1 from "tslib";
import { Auth } from 'aws-amplify';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
export class AuthService {
    constructor(document) {
        this.document = document;
        this.window = this.document.defaultView;
    }
    getRandomString(bytes) {
        const randomValues = new Uint8Array(bytes);
        this.window.crypto.getRandomValues(randomValues);
        return Array.from(randomValues).map(this.intToHex).join('');
    }
    intToHex(nr) {
        return nr.toString(16).padStart(2, '0');
    }
    signUp(fullName, mobile, email, preferred_username, profile) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const params = {
                username: mobile,
                password: this.getRandomString(30),
                attributes: {
                    name: fullName,
                    phone_number: mobile,
                    email: email,
                    preferred_username: preferred_username,
                    profile: profile
                }
            };
            if (localStorage.getItem('campaign') === 'b2c') {
                params.attributes['profile'] = 'b2c';
            }
            yield Auth.signUp(params);
        });
    }
    updateUserUuId(useruuId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const userDetails = yield Auth.userAttributes(this.cognitoUser);
            var customUpdated = false;
            // to know if 'useruuId' is set 
            for (var key in userDetails) {
                if (userDetails[key].getName() == 'custom:useruuId') {
                    customUpdated = true;
                    break;
                }
            }
            ;
            //if not set we ned to set 'useruuId' as the same value as 'sub'
            if (customUpdated == false) {
                // for(var key in userDetails){
                //   if(userDetails[key].getName()=='sub' ){
                //     const result = Auth.updateUserAttributes(this.cognitoUser, {
                //       'custom:useruuId': userDetails[key].getValue()           
                //     }          
                //   );
                //   break;    
                //   }
                // };
                const result = Auth.updateUserAttributes(this.cognitoUser, {
                    'custom:useruuId': useruuId
                });
            }
        });
    }
    signIn(mobile) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.cognitoUser = yield Auth.signIn(mobile);
        });
    }
    answerCustomChallenge(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.cognitoUser = yield Auth.sendCustomChallengeAnswer(this.cognitoUser, data);
            return this.isAuthenticated();
        });
    }
    isAuthenticated() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                yield Auth.currentSession();
                return true;
            }
            catch (_a) {
                return false;
            }
        });
    }
    signOut() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield Auth.signOut();
            localStorage.clear();
        });
    }
}
AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.DOCUMENT)); }, token: AuthService, providedIn: "root" });
